import { render } from "./Post.vue?vue&type=template&id=34c71669&lang=pug"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=34c71669&lang=css"
script.render = render

export default script